module.exports = __webpack_public_path__ + "static/telecom-7e1270e5606d613171abda78c6dcf174.webp";